// routes/_authenticated/fundos/dashboard.tsx — entry point for `/fundos/dashboard`.
// The page lives in `@/features/fundos-dashboard`; this file is just router glue.

import { createFileRoute } from "@tanstack/react-router";

import { FundosDashboardPage } from "@/features/fundos-dashboard";

export const Route = createFileRoute("/_authenticated/fundos/dashboard")({
  component: FundosDashboardPage,
});
